var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("TeamStatusControl", {
    attrs: { subject: _vm.slide.uuid, type: "values" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }